<template>
  <SoPageWithHeader>
    <OpsReferralCodeDetails />
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import OpsReferralCodeDetails from "./components/OpsReferralCodeDetails.vue"

  export default defineComponent({
    components: { OpsReferralCodeDetails, SoPageWithHeader },
  })
</script>
